/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { ReactNode } from 'react';
import { HIDE, SHOW } from '../styles/animations';
import { css, SerializedStyles } from '@emotion/react';


/**
 * Switcher: a component that takes a number of child elements, and renders the one at the given index. If the given
 * index is out of bounds, renders nothing. Accepts children that are null/undefined or any other ReactNode
 * Uses a fade animation to transition between elements.
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default class Switcher extends React.PureComponent<{
  /**
   * the index of the child to render right now
   */
  selectedIndex: number,
  rootCss?: SerializedStyles,
  children: ReactNode[],
}> {
  public showChildByIndex(child: ReactNode, i: number) {
    const element = child as React.ReactElement<any>;

    // If we can't add a class to the given element, wrap it and return it with the right style.
    if (!element || !element.props || !element.props.className) {
      return <div css={i === this.props.selectedIndex ? SHOW : HIDE}>{child}</div>;
    }

    return React.cloneElement(element, {
      className: css`${element.props.className}; ${i === this.props.selectedIndex ? SHOW : HIDE};`,
    });
  }


  public render = () => (
    React.Children.map(this.props.children, (child, i) => this.showChildByIndex(child, i))
  );
}
